export class NotFoundSharedError extends Error {
  static create(errorMessage) {
    return new NotFoundSharedError(errorMessage)
  }
}
